import Vue from 'vue';
import Router from 'vue-router';

import webRouter from './module/webRouter';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [...webRouter],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};




// WEBPACK FOOTER //
// ./src/router/index.js